<template>
  <div class="item-container h-full overflow-hidden">
    <el-card class="m-4 relative overflow-hidden h-full" :body-style="{ padding: '0' }">
      <el-scrollbar class="w-full h-full" wrap-class="overflow-x-hidden">
        <!-- 标题部分 -->
        <div
          class="card-title text-medium-x leading-22 font-normal mx-6 mt-6 mb-4 text-theme-black-850 flex"
          v-if="title || $slots.title"
        >
          <div v-if="$slots.title"><slot name="title" /></div>
          <div class="flex" v-else>
            <span class="ml-5 font-semibold">{{ title }}</span>
            <div class="text-theme-black-450 ml-1 text-small font-normal leading-22" v-if="subTitle">
              <span>{{ subTitle }}</span>
            </div>
            <slot name="icon" />
          </div>
        </div>

        <!-- 内容部分 -->
        <div class="card-body mx-6 mb-6">
          <slot />
        </div>

        <!-- 状态角标 -->
        <div class="absolute top-0 right-0" v-if="$slots.state">
          <slot name="state" slot-scope="" />
        </div>
      </el-scrollbar>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ItemContainer',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.card-title::before {
  content: '';
  @apply bg-theme block float-left w-1 h-5 -ml-6;
  margin-top: 1px;
}
.el-card {
  @apply shadow-theme;
  height: calc(100% - 32px);
  border: none;
}
</style>
